import { useEffect } from "react";
import { toast } from "react-toastify";

const useToastOnError = (
  isError: boolean,
  error: { message?: string } | null | undefined,
  fallbackMessage: string,
  onError?: () => void,
) => {
  useEffect(() => {
    if (!isError) return;

    toast.error(error?.message || fallbackMessage);
    onError?.();
  }, [isError, error, fallbackMessage, onError]);
};

export default useToastOnError;
